import { AddMemberPopupComponent } from './list-member/small-group/add-member-popup.component';
import { LargeGroupComponent } from './list-member/large-group/large-group.component';
import { SmallGroupComponent } from './list-member/small-group/small-group.component';
import { ListMemberComponent } from './list-member/list-member.component';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RequestAppointmentRoutingModule } from './request-appointment.routing';
import { RequestAppointmentComponent } from './request-appointment.component';
import { SharedModule } from '../../shared/shared.module';
import { ViewCalendarComponent } from './view-calendar/view-calendar.component';
import { ScheduleModule } from 'primeng/primeng';
@NgModule({
    declarations: [
        RequestAppointmentComponent,
        ViewCalendarComponent,
        ListMemberComponent,
        SmallGroupComponent,
        LargeGroupComponent,
        AddMemberPopupComponent
    ],
    imports: [RequestAppointmentRoutingModule, SharedModule, ReactiveFormsModule, FormsModule, CommonModule, ScheduleModule],
    entryComponents: [
      AddMemberPopupComponent
    ],
    providers: [],
    bootstrap: []
})
export class RequestAppointmentModule {
}




// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/request-appointment/request-appointment.module.ts